import {
  ListViewComponent,
  listRow,
  getExtraBurgerMenuOptions,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { MatDialog } from '@angular/material/dialog';
import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { LogService } from 'BaseServices/log-service';
import { AgreementService } from 'projects/Assets/src/assets-base/Services/agreement-service';
import {
  BaseListPageComponent,
  multiSelectFilterList,
} from 'src/app/BasePages/base-list-page/base-list-page.component';
import {
  AgreementDetailDTO,
  AgreementSummaryDTO,
  ClientSummaryDTO,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import { MainService } from 'BaseServices/main-service';
import { forkJoin } from 'rxjs';
import { AgreementDialogComponent } from 'projects/Assets/src/assets-base/Dialogs/agreement-dialog/agreement-dialog.component';

@Component({
  selector: 'app-agreement-view',
  imports: [MatButtonModule, BaseListPageComponent],
  templateUrl: './agreement-view.component.html',
  styleUrls: [
    '../../../../../../src/app/general-styles/pages.css',
    './agreement-view.component.css',
  ],
})
export class AgreementViewComponent implements AfterViewInit {
  extraBurgerMenuOptions: MenuOption[] = [];
  headerList: string[] = [
    'Kunde',
    'Anlæg',
    'Tidspunkt',
    'Sidste fakturerings Tidspunkt',
    'Sidste faktura værdi',
    'Næste fakturerings Tidspunkt',
    'Næste faktura værdi',
  ];
  @ViewChild('baseListPage')
  baseListPage!: BaseListPageComponent<AgreementSummaryDTO>;
  readonly dialog = inject(MatDialog);
  logHeaderList: string[];

  multiSelectFilterLists: multiSelectFilterList[] = [];
  agreements: AgreementSummaryDTO[] = [];
  clients: ClientSummaryDTO[] = [];
  plants: PlantSummaryDTO[] = [];
  constructor(
    private mainService: MainService,
    private logService: LogService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('aftale'); // Lige nu ser den ud til at være lavet til specifikt timelog så vi skal tage en beslutning med det her
  }

  ngAfterViewInit(): void {
    this.updateListAgreements();
  }
  updateMultiSelectFilterLists() {
    var list: multiSelectFilterList[] = [];

    var clientList: multiSelectFilterList = {
      Items: this.clients.map((c) => ({ name: c.name, id: c.id })),
      selectedItemsIds: this.clients.map((c) => c.id),
      placeHolderText: 'Vælg Kunde',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (agreement: AgreementSummaryDTO) {
        if (!agreement) return false;
        if (!agreement.clientName) return false;
        const match = this.Items.find((i: any) => i.name === agreement.clientName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 0,
    };
    list.push(clientList);

    var plantList: multiSelectFilterList = {
      Items: this.plants.map((p) => ({ name: p.plantName, id: p.id })),
      selectedItemsIds: this.plants.map((p) => p.id),
      placeHolderText: 'Vælg Anlæg',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (agreement: AgreementSummaryDTO) {
        if (!agreement) return false;
        if (!agreement.plantName) return true;
        const match = this.Items.find((i: any) => i.name === agreement.plantName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 1,
    };
    list.push(plantList);

    this.multiSelectFilterLists = list;
  }
  agreementClicked = (agreement?: AgreementSummaryDTO) => {
    var today = new Date();
    var agreementRequest: AgreementDetailDTO;

    const clientId = agreement?.clientName
      ? this.clients.find((c) => c.name === agreement.clientName)?.id ?? 0
      : 0;
    const plantId = agreement?.plantName
      ? this.plants.find((p) => p.plantName === agreement.plantName)?.id ?? null
      : undefined;

    agreementRequest = {
      id: agreement?.id ?? 0,
      clientId: clientId,
      plantId: plantId,

      creationDate: agreement?.creationDate ?? today,
      lastInvoiceDate: agreement?.lastInvoiceDate ?? null,
      lastInvoiceValue: agreement?.lastInvoiceValue ?? 0,
      nextInvoiceDate: agreement?.nextInvoiceDate ?? null,
      nextInvoiceValue: agreement?.nextInvoiceValue ?? 0,
    };
    let dialogRef = this.dialog.open(AgreementDialogComponent, {
      data: { data: [agreementRequest] },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.updateListAgreements();
      }
    });
  };

  switchDataInList() {
    // TODO få til at ligne den i courseParticipant componetn
  }

  updateListAgreements() {
    forkJoin({
      agreements: this.mainService.getAll<AgreementSummaryDTO>('agreement'),
      clients: this.mainService.getAll<ClientSummaryDTO>('client'),
      plants: this.mainService.getAll<PlantSummaryDTO>('plant'),
    }).subscribe(({ agreements, clients, plants }) => {
      this.plants = plants;
      this.clients = clients;
      this.agreements = agreements;
      this.updateMultiSelectFilterLists();

      let listData: listRow<AgreementSummaryDTO>[] = [];
      agreements.forEach((agreement) => {
        listData.push({
          object: agreement,
          id: agreement.id,
          data: [
            agreement.clientName ?? '',
            agreement.plantName ?? '',
            new Date(agreement.creationDate),
            agreement.lastInvoiceDate
              ? new Date(agreement.lastInvoiceDate)
              : '',
            agreement.lastInvoiceValue?.toString() ?? '',
            agreement.nextInvoiceDate
              ? new Date(agreement.nextInvoiceDate)
              : '',
            agreement.nextInvoiceValue?.toString() ?? '',
          ],
        });
      });
      this.baseListPage.UpdateListData(listData);
    });
  }
}
